export { default as compareNatural } from './compareNatural';
export { default as matchesQuery } from './matchesQuery';
export { default as queryScore } from './queryScore';
export { default as cleanServiceClassname } from './cleanServiceClassname';
export {
  isBeta,
  isBuiltIn,
  isDeprecated,
  isFeatured,
  isHidden,
  isPremium,
  isInvite,
  isPublic,
  isOauth,
  hasUpfrontFields,
} from './identifiers';
export { getVersion, hasVersion, stripVersion } from './versions';
